import React from 'react';
import { transform } from '@babel/core';
class Image extends React.Component {
    constructor(props) {
        super(props);
        this.state = {}
    }
    render() {
        return (
            <img src={this.props.img}
                style={{ width: '100%', height: '60%', objectFit: 'cover' }}
            />

        )
    }
}
export { Image }